import type {SVGProps} from 'react';

export function Fa7Solid2(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M176 128c0-17.7 14.3-32 32-32h171c60.2 0 109 48.8 109 109c0 43.8-26.2 83.3-66.4 100.4l-139.1 59c-35.5 15-58.5 49.8-58.5 88.3V480h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32v-59.3c0-64.2 38.4-122.2 97.5-147.3l139.1-59C413.2 239.3 424 223 424 205c0-24.9-20.2-45-45-45H208c-17.7 0-32-14.3-32-32"></path>
    </svg>);
}